/**
 * Shared react-hook-form validator for file/input size constraints. Returns
 * `true` when valid, or an error message string when invalid — matching the
 * `validate` contract of react-hook-form's `register`/`Controller` rules.
 *
 * NOTE: Because we deal with numbers, using `!numberOfBytes` is not safe. It
 * would cause a false positive on the number 0.
 */

export const maxFileSizeValidator = (
  numberOfBytes: number | undefined,
  config: { maxInBytes?: number; errorMessage?: string } = {}
) => {
  if (numberOfBytes === undefined) {
    return true;
  }

  return (
    numberOfBytes <= (config.maxInBytes ?? Number.MAX_SAFE_INTEGER) ||
    config.errorMessage
  );
};
